// Returns path to image asset
export const asset = (path) => "/content/themes/tpt/dist/images/" +
  ((path && path.startsWith("/")) ? path.substring(1, path.length) : path);